import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import DeleteActionIcon from 'icons/DeleteActionIcon'

const DeleteButton = ({ onClick }) => (
  <IconButton onClick={onClick} label="Delete">
    <DeleteActionIcon />
  </IconButton>
)

export default DeleteButton
